// 集合处理类

function mackEntitites() {
  return {Rows: []};
}

/**
 * 审核流程状态
 * @returns {{Rows: *[]}}
 */
export function getMemberFlowStatusEntities() {
  var aEntitites = mackEntitites();
  aEntitites.Rows.push({name: "专员待审核", value: 5,operateName: "会员提交",});
  aEntitites.Rows.push({name: "待分管领导审核", value: 10,operateName: "审核通过",});
  aEntitites.Rows.push({name: "专员驳回", value: 15,operateName: "驳回",});
  aEntitites.Rows.push({name: "待工作委员会审核", value: 18,operateName: "审核通过",});
  aEntitites.Rows.push({name: "分管领导未通过", value: 19,operateName: "驳回",});
  aEntitites.Rows.push({name: "待秘书长审核", value: 20,operateName: "审核通过",});
  aEntitites.Rows.push({name: "工作委员会未通过", value: 25,operateName: "驳回",});
  aEntitites.Rows.push({name: "秘书长审核通过", value: 30,operateName: "审核通过",});
  aEntitites.Rows.push({name: "秘书长未通过", value: 35,operateName: "驳回",});
  return aEntitites;
}
// 会员审批状态
export function getMemberApprovalStateEntities() {
  var aEntitites = mackEntitites();
  aEntitites.Rows.push({name: "待审核", value: 1});
  aEntitites.Rows.push({name: "已审核", value: 2});
  aEntitites.Rows.push({name: "审核不通过", value: 3});
  return aEntitites;
}

// 审批状态
export function getApprovalStateEntities2() {
  var aEntitites = mackEntitites();
  aEntitites.Rows.push({name: "全部", value: 4});
  aEntitites.Rows.push({name: "待提交", value: 0});
  aEntitites.Rows.push({name: "待审核", value: 1});
  aEntitites.Rows.push({name: "已审核", value: 2});
  aEntitites.Rows.push({name: "审核不通过", value: 3});
  return aEntitites;
}

// 审批状态
export function getApprovalStateEntities() {
  var aEntitites = mackEntitites();
  aEntitites.Rows.push({name: "待审核", value: 1});
  aEntitites.Rows.push({name: "已审核", value: 2});
  return aEntitites;
}

/**-
 * 获取专业
 */
export function getMajorEntities() {
  var aEntitites = mackEntitites();
  aEntitites.Rows.push({name: "修缮施工", value: "1"});
  aEntitites.Rows.push({name: "修缮材料", value: "2"});
  aEntitites.Rows.push({name: "监理造价", value: "3"});
  aEntitites.Rows.push({name: "电梯", value: "4"});
  aEntitites.Rows.push({name: "实施与查勘设计", value: "5"});
  aEntitites.Rows.push({name: "历保建筑", value: "7"});
  aEntitites.Rows.push({name: "其他", value: "99"});
  return aEntitites;
}

/**
 * 用户专业
 */
export function getUSerMajorEntities() {
  var aEntitites = mackEntitites();
  aEntitites.Rows.push({name: "修缮施工", value: "1"});
  aEntitites.Rows.push({name: "修缮材料", value: "2"});
  aEntitites.Rows.push({name: "监理造价", value: "3"});
  aEntitites.Rows.push({name: "电梯", value: "4"});
  aEntitites.Rows.push({name: "实施与查勘设计", value: "5"});
  aEntitites.Rows.push({name: "历保建筑", value: "7"});
  return aEntitites;
}

/**
 * 获取注册专业
 * @returns {{Rows: []}}
 */
export function getRegiestMajorEntities() {
  var aEntitites = mackEntitites();
  aEntitites.Rows.push({name: "修缮施工", value: "1", fileType: ["DWJJ", "YYZZ", "ZZZS", "QTCL"]});
  aEntitites.Rows.push({name: "电梯", value: "2", fileType: ["DWJJ", "YYZZ", "TZSBXKZ", "QTCL"]});
  aEntitites.Rows.push({name: "监理造价", value: "3", fileType: ["DWJJ", "YYZZ", "ZZZS", "QTCL"]});
  aEntitites.Rows.push({name: "修缮材料", value: "4", fileType: ["DWJJ", "YYZZ", "SCXKZ", "QTCL", "CLBAZ"]});
  aEntitites.Rows.push({name: "实施与查勘设计", value: "5", fileType: ["DWJJ", "YYZZ", "ZZZS", "QTCL"]});
  aEntitites.Rows.push({name: "其他", value: "6", fileType: ["DWJJ", "YYZZ", "QTCL"]});
  aEntitites.Rows.push({name: "历保建筑", value: "7", fileType: ["DWJJ", "YYZZ", "ZZZS", "QTCL"]});
  return aEntitites;

}

/**
 * 协会职务
 */
export function getAssociationDutiesEntities() {
  var aEntitites = mackEntitites();
  aEntitites.Rows.push({name: "一般会员单位", value: "1", standard: 3000});
  aEntitites.Rows.push({name: "理事单位", value: "2", standard: 6000});
  aEntitites.Rows.push({name: "常务理事单位", value: "3", standard: 10000});
  aEntitites.Rows.push({name: "副会长单位", value: "4", standard: 18000});
  aEntitites.Rows.push({name: "常务副会长单位", value: "5", standard: 20000});
  aEntitites.Rows.push({name: "会长单位", value: "6", standard: 20000});
  aEntitites.Rows.push({name: "监事单位", value: "7", standard: 6000});
  aEntitites.Rows.push({name: "监事长单位", value: "8", standard: 20000});
  return aEntitites;
}

/**
 * 将对象中的Rows数组对象，按某个字段建立Key
 * @param entities 对象-需要包含Rows的对象数组
 * @param fieldName 要建立key的字段名称
 */
export function buildEntitesIndexX(entities, fieldName) {
  if (!entities.Rows) {
    return
  }
  for (var i = 0; i < entities.Rows.length; i++) {
    var row = entities.Rows[i]
    var sName = row[fieldName]
    entities[sName] = row
  }
  return entities
}

export function getRewardsPunishmentsTypeEntities() {
  var aEntitites = mackEntitites();
  aEntitites.Rows.push({name: "奖励", value: 1});
  aEntitites.Rows.push({name: "惩罚", value: 2});
  aEntitites.Rows.push({name: "其他情况", value: 3});
  return aEntitites;
}

export function getStateEntities() {
  var aEntitites = mackEntitites();
  aEntitites.Rows.push({name: "未生效", value: 1});
  aEntitites.Rows.push({name: "正常", value: 2});
  aEntitites.Rows.push({name: "退会", value: 3});
  return aEntitites;
}

/**
 * 党组织
 * @returns {{Rows: Array}}
 */
export function getDZZEntities() {
  var aEntitites = mackEntitites();
  aEntitites.Rows.push({name: "党支部", value: 1});
  aEntitites.Rows.push({name: "党总支", value: 2});
  aEntitites.Rows.push({name: "党委", value: 3});
  return aEntitites;
}

/**
 * 获取数据字典分组
 * @returns {{Rows: []}}
 */
export function getGroupTitleEntities() {
  var aEntitites = mackEntitites();
  aEntitites.Rows.push({name: "基本账户开户行", value: "1"});
  aEntitites.Rows.push({name: "机构类型", value: "2"});
  aEntitites.Rows.push({name: "机构类型(注册)", value: "5"});
  aEntitites.Rows.push({name: "登记注册类型", value: "3"});
  aEntitites.Rows.push({name: "专家申请专业", value: "4"});
  return aEntitites;
}

/**
 * 专家状态
 * @returns {{Rows: []}}
 */
export function getExpertStatusEntities() {
  let aEntities = mackEntitites();
  aEntities.Rows.push({name: "正常", value: "1"});
  aEntities.Rows.push({name: "暂停", value: "2"});
  return aEntities;
}


/**
 * 性别
 * @returns {{Rows: []}}
 */
export function getSexEntities() {
  let aEntities = mackEntitites();
  aEntities.Rows.push({name: "男", value: 1});
  aEntities.Rows.push({name: "女", value: 0});
  return aEntities;
}

/**
 * 学历
 * @returns {{Rows: []}}
 */
export function getEducationalEntities() {
  let aEntities = mackEntitites();
  // aEntities.Rows.push({name: "小学", value: 1});
  // aEntities.Rows.push({name: "初中", value: 2});
  // aEntities.Rows.push({name: "高中", value: 3});
  // aEntities.Rows.push({name: "中专", value: 4});
  aEntities.Rows.push({name: "大专", value: 5});
  aEntities.Rows.push({name: "本科", value: 6});
  aEntities.Rows.push({name: "研究生", value: 7})
  aEntities.Rows.push({name: "博士", value: 8});
  return aEntities;
}

/**
 *  工作状态
 */
export function getWorkStateEntities() {
  let aEntities = mackEntitites();
  aEntities.Rows.push({name: "在职", value: 1})
  aEntities.Rows.push({name: "退休", value: 2});
  return aEntities;
}

/**
 * 项目抽取状态
 * @returns {{Rows: []}}
 */
export function getProjectExtractStatusEntities() {
  let aEntities = mackEntitites();
  aEntities.Rows.push({name: "未抽取", value: "0"});
  aEntities.Rows.push({name: "已抽取", value: "1"});
  return aEntities;
}

/**
 * 项目状态
 * @returns {{Rows: []}}
 */
export function getProjectStatusEntities() {
  let aEntities = mackEntitites();
  aEntities.Rows.push({name: "未提交", value: "0"});
  aEntities.Rows.push({name: "已提交", value: "1"});
  return aEntities;
}

/**
 * 项目评审时间类别
 * @returns {{Rows: []}}
 */
export function getProjectEvaluationDateCategoryEntities() {
  let aEntities = mackEntitites();
  aEntities.Rows.push({name: "上午", value: 1});
  aEntities.Rows.push({name: "下午", value: 2});
  aEntities.Rows.push({name: "全天", value: 3});
  return aEntities;
}

/**
 * 专家抽取状态
 * @returns {{Rows: []}}
 */
export function getExpertExtractStatusEntities() {
  let aEntities = mackEntitites();
  aEntities.Rows.push({name: "待确认", value: 0});
  aEntities.Rows.push({name: "参加", value: 1});
  aEntities.Rows.push({name: "不参加", value: 2});
  aEntities.Rows.push({name: "无应答", value: 3});
  return aEntities;
}

/**
 * 项目专家确认方式
 * @returns {{Rows: []}}
 */
export function getProjectExpertCfgMethodEntities() {
  let aEntities = mackEntitites();
  aEntities.Rows.push({name: "随机抽取", value: 1});
  aEntities.Rows.push({name: "直接确定", value: 2});
  return aEntities;
}

/**
 * 工程性质
 */
export function getProjectTypeEntities() {
  let aEntities = mackEntitites();
  // aEntities.Rows.push({
  //   label: '住宅修缮工程', value: '住宅修缮工程', children: [{
  //     value: '全项目大修工程',
  //     label: '全项目大修工程',
  //   }, {
  //     value: '屋面及相关设施改造工程',
  //     label: '屋面及相关设施改造工程',
  //   }, {
  //     value: '厨卫综合改造工程',
  //     label: '厨卫综合改造工程',
  //
  //   }, {
  //     value: '高层住宅外立面整治工程',
  //     label: '高层住宅外立面整治工程',
  //   }]
  // });
  // aEntities.Rows.push({label: '历史保护建筑修缮工程', value: '历史保护建筑修缮工程'})
  // aEntities.Rows.push({label: '既有多层住宅加装电梯工程', value: '既有多层住宅加装电梯工程'})
  // aEntities.Rows.push({label: '成套改造工程', value: '成套改造工程'})
  aEntities.Rows.push({label: '旧住房综合改造项目', value: '旧住房综合改造项目'})
  aEntities.Rows.push({label: '优秀历史建筑', value: '优秀历史建筑'})
  aEntities.Rows.push({label: '成套改造、城市更新项目', value: '成套改造、城市更新项目'})
  aEntities.Rows.push({label: '里弄房屋项目、建筑装饰装修、厨卫综合改造项目', value: '里弄房屋项目、建筑装饰装修、厨卫综合改造项目'})


  return aEntities
}

/**
 * 退会类型
 */
export function getApplyTypeEntities() {
  let aEntities = mackEntitites();
  aEntities.Rows.push({name: '自行退会', value: 'zxth'});
  aEntities.Rows.push({name: '被退会', value: 'bth'})
  return aEntities
}

/**
 * 区修缮管理部
 */

export function getQxsglb() {
  let aEntities = mackEntitites();
  aEntities.Rows.push({name: "宝山区修缮管理部门", value: "宝山区修缮管理部门", key: 1})
  aEntities.Rows.push({name: "崇明区修缮管理部门", value: "崇明区修缮管理部门", key: 2})
  aEntities.Rows.push({name: "奉贤区修缮管理部门", value: "奉贤区修缮管理部门", key: 3})
  aEntities.Rows.push({name: "虹口区修缮管理部门", value: "虹口区修缮管理部门", key: 4})
  aEntities.Rows.push({name: "黄浦区修缮管理部门", value: "黄浦区修缮管理部门", key: 5})
  aEntities.Rows.push({name: "嘉定区修缮管理部门", value: "嘉定区修缮管理部门", key: 6})
  aEntities.Rows.push({name: "金山区修缮管理部门", value: "金山区修缮管理部门", key: 7})
  aEntities.Rows.push({name: "静安区修缮管理部门", value: "静安区修缮管理部门", key: 8})
  aEntities.Rows.push({name: "闵行区修缮管理部门", value: "闵行区修缮管理部门", key: 9})
  aEntities.Rows.push({name: "普陀区修缮管理部门", value: "普陀区修缮管理部门", key: 10})
  aEntities.Rows.push({name: "青浦区修缮管理部门", value: "青浦区修缮管理部门", key: 11})
  aEntities.Rows.push({name: "松江区修缮管理部门", value: "松江区修缮管理部门", key: 12})
  aEntities.Rows.push({name: "徐汇区修缮管理部门", value: "徐汇区修缮管理部门", key: 13})
  aEntities.Rows.push({name: "杨浦区修缮管理部门", value: "杨浦区修缮管理部门", key: 14})
  aEntities.Rows.push({name: "长宁区修缮管理部门", value: "长宁区修缮管理部门", key: 15})
  aEntities.Rows.push({name: "浦东新区修缮管理部门", value: "浦东新区修缮管理部门", key: 16})
  aEntities.Rows.push({name: "上海市历史建筑保护事务中心", value: "上海市历史建筑保护事务中心", key: 17})
  return aEntities

}
/**
 * 材料类别
 */
export function getMaterialType() {
  let aEntities = mackEntitites();
  aEntities.Rows.push({name: "建筑涂料类", value: "建筑涂料类", key: 1})
  aEntities.Rows.push({name: "管道类", value: "管道类", key: 2})
  aEntities.Rows.push({name: "防水材料类", value: "防水材料类", key: 3})
  aEntities.Rows.push({name: "其他", value: "其他", key: 4})
  return aEntities
}
/**
 * 职业/工种
 */
export function getWorkTypeEntities() {
  let aEntities = mackEntitites();
  aEntities.Rows.push({name: "手工木工", value: "手工木工", code: "6-06-03-01", key: 1})
  aEntities.Rows.push({name: "砌筑工", value: "砌筑工", code: "6-29-01-01", key: 2})
  aEntities.Rows.push({name: "抹灰工", value: "抹灰工", code: "6-29-04-01", key: 3})
  return aEntities
}
/**
 * 申报认定等级
 */
export function getAppraisalLevelEntities() {
  let aEntities = mackEntitites();
  aEntities.Rows.push({name: "初级/五级", value: "初级/五级", key: 1})
  aEntities.Rows.push({name: "中级/四级", value: "中级/四级", key: 2})
  aEntities.Rows.push({name: "高级/三级", value: "高级/三级", key: 3})
  aEntities.Rows.push({name: "技师/二级", value: "技师/二级", key: 4})
  aEntities.Rows.push({name: "高级技师/一级", value: "高级技师/一级", key: 5})
  return aEntities
}
/**
 * 认定方式
 */
export function getRdModeEntities() {
  let aEntities = mackEntitites();
  aEntities.Rows.push({name: "常规认定", value: "常规认定", key: 1})
  aEntities.Rows.push({name: "直接认定", value: "直接认定", key: 2})
  return aEntities
}

/**
 * 现有技能等级
 */
export function getAppraisalLevelEntities2() {
  let aEntities = mackEntitites();
  aEntities.Rows.push({name: "无", value: "无", key: 1})
  aEntities.Rows.push({name: "初级/五级", value: "初级/五级", key: 2})
  aEntities.Rows.push({name: "中级/四级", value: "中级/四级", key: 3})
  aEntities.Rows.push({name: "高级/三级", value: "高级/三级", key: 4})
  aEntities.Rows.push({name: "技师/二级", value: "技师/二级", key: 5})
  aEntities.Rows.push({name: "高级技师/一级", value: "高级技师/一级", key: 6})
  return aEntities
}
/**
 * 人员类别
 */
export function getPersonTypeEntities() {
  let aEntities = mackEntitites();
  aEntities.Rows.push({name: "在职职工", value: "在职职工", key: 1})
  aEntities.Rows.push({name: "劳务派遣工", value: "劳务派遣工", key: 2})
  aEntities.Rows.push({name: "劳务工", value: "劳务工", key: 3})
  return aEntities
}
/**
 * 现有技能职称
 */
export function getTitleGradesEntities() {
  let aEntities = mackEntitites();
  aEntities.Rows.push({name: "无", value: "无", key: 1})
  aEntities.Rows.push({name: "初级", value: "初级", key: 2})
  aEntities.Rows.push({name: "中级", value: "中级", key: 3})
  aEntities.Rows.push({name: "高级", value: "高级", key: 4})
  return aEntities
}
/**
 * 科目（模块名称）
 */
export function getSubjectEntities() {
  let aEntities = mackEntitites();
  aEntities.Rows.push({name: "理论知识", value: "理论知识", key: 1})
  aEntities.Rows.push({name: "操作技能", value: "操作技能", key: 2})
  return aEntities
}
/**
 * 证件类型
 */
export function getaAsessmentTypeEntities() {
  let aEntities = mackEntitites();
  aEntities.Rows.push({name: "身份证", value: 1, key: 1})
  aEntities.Rows.push({name: "护照", value: 2, key: 2})
  aEntities.Rows.push({name: "港澳通行证", value: 3, key: 3})
  aEntities.Rows.push({name: "其他", value: 4, key: 4})
  return aEntities
}

export function getkwryEntities() {
  let aEntities = mackEntitites();
  aEntities.Rows.push({name: "考务人员", value: 1, key: 1})
  aEntities.Rows.push({name: "督导员", value: 2, key: 2})
  aEntities.Rows.push({name: "考评员", value: 3, key: 3})
  return aEntities
}

export function getcdTypeEntities() {
  let aEntities = mackEntitites();
  aEntities.Rows.push({name: "考核点", value: 1, key: 1})
  aEntities.Rows.push({name: "培训点", value: 2, key: 2})
  return aEntities
}

export function getcdLevelEntities() {
  let aEntities = mackEntitites();
  aEntities.Rows.push({name: "高级技师/一级", value: 1, key: 1})
  aEntities.Rows.push({name: "技师/二级", value: 2, key: 2})
  aEntities.Rows.push({name: "高级/三级", value: 3, key: 3})
  aEntities.Rows.push({name: "中级/四级", value: 4, key: 4})
  aEntities.Rows.push({name: "初级/五级", value: 5, key: 5})
  return aEntities;
}

export function getDdEntities() {
  let aEntities = mackEntitites();
  aEntities.Rows.push({name: "优秀", value: "优秀", key: 1})
  aEntities.Rows.push({name: "良好", value: "良好", key: 2})
  aEntities.Rows.push({name: "合格", value: "合格", key: 3})
  aEntities.Rows.push({name: "不合格", value: "不合格", key: 4})
  return aEntities;
}
/**
* 政治面貌
*/
export function getPoliticalStatusEntities() {
  let aEntities = mackEntitites();
  aEntities.Rows.push({name: "共产党员", value: "共产党员", key: 1})
  aEntities.Rows.push({name: "民主党派", value: "民主党派", key: 2})
  aEntities.Rows.push({name: "共青团员", value: "共青团员", key: 3})
  aEntities.Rows.push({name: "群众", value: "群众", key: 4})
  aEntities.Rows.push({name: "其他", value: "其他", key: 5})
  return aEntities
}


export function getYears() {
  //起始年度
  let stYear = "2021";
  let date = new Date();
  let year = date.getFullYear(); //获取完整的年份(4位)
  var aEntitites = mackEntitites();
  aEntitites.Rows.push({name: stYear, value: stYear});
  for (let i = 0; ; i++) {
    if (stYear == year) {
      break;
    } else {
      stYear = parseInt(stYear) + 1;
      aEntitites.Rows.push({name: stYear, value: stYear});
    }
  }
  return aEntitites;
}

// 专业评估单位登记状态
export function getPxglStatus() {
  var aEntitites = mackEntitites();
  aEntitites.Rows.push({name: "待提交", value: 1});
  aEntitites.Rows.push({name: "待审核", value: 2});
  aEntitites.Rows.push({name: "通过", value: 3});
  aEntitites.Rows.push({name: "不通过", value: 4});
  aEntitites.Rows.push({name: "退回材料整改", value: 5});

  return aEntitites;
}
export function getPgShStatus() {
  var aEntitites = mackEntitites();
  // aEntitites.Rows.push({name: "待提交", value: 1});
  aEntitites.Rows.push({name: "待审核", value: 2});
  aEntitites.Rows.push({name: "通过", value: 3});
  aEntitites.Rows.push({name: "不通过", value: 4});
  aEntitites.Rows.push({name: "退回材料整改", value: 5});

  return aEntitites;
}
export function getPgdjStatus() {
  var aEntitites = mackEntitites();
  // aEntitites.Rows.push({name: "待提交", value: 1});
  aEntitites.Rows.push({name: "已提交", value: 2});
  aEntitites.Rows.push({name: "通过", value: 3});
  aEntitites.Rows.push({name: "不通过", value: 4});
  aEntitites.Rows.push({name: "退回材料整改", value: 5});

  return aEntitites;
}
export function getPxShStatus() {
  var aEntitites = mackEntitites();
  aEntitites.Rows.push({name: "通过", value: 3});
  aEntitites.Rows.push({name: "不通过", value: 4});
  aEntitites.Rows.push({name: "退回材料整改", value: 5});

  return aEntitites;
}

// 单位类别
export function getPxglDwlb() {
  var aEntitites = mackEntitites();
  aEntitites.Rows.push({name: "上海市房屋检测鉴定公示单位", value: 1});
  aEntitites.Rows.push({name: "上海市建设工程检测机构", value: 2});

  return aEntitites;
}
export function getPxRyglDwlb() {
  var aEntitites = mackEntitites();
  aEntitites.Rows.push({name: "上海市房屋检测鉴定公示单位", value: 1});
  aEntitites.Rows.push({name: "上海市建设工程检测机构", value: 2});

  return aEntitites;
}
// 培训人员状态
export function getPxzgRyStatus(type) {
  var aEntitites = mackEntitites();
  if(type===1){
    aEntitites.Rows.push({name: "待提交", value: 1});
    aEntitites.Rows.push({name: "待审核", value: 2});
    aEntitites.Rows.push({name: "通过", value: 3});
    aEntitites.Rows.push({name: "不通过", value: 4});
    aEntitites.Rows.push({name: "退回整改", value: 5});
    aEntitites.Rows.push({name: "其他", value: 6});
  }
  else if(type===2){
    aEntitites.Rows.push({name: "待审核", value: 2});
    aEntitites.Rows.push({name: "通过", value: 3});
    aEntitites.Rows.push({name: "不通过", value: 4});
    aEntitites.Rows.push({name: "退回整改", value: 5});
    aEntitites.Rows.push({name: "其他", value: 6});
  }else if(type===3) {
    aEntitites.Rows.push({name: "已提交", value: 2});
    aEntitites.Rows.push({name: "通过", value: 3});
    aEntitites.Rows.push({name: "不通过", value: 4});
    aEntitites.Rows.push({name: "退回整改", value: 5});
    aEntitites.Rows.push({name: "其他", value: 6});
  }else if(type===4){
    aEntitites.Rows.push({name: "通过", value: 3});
    aEntitites.Rows.push({name: "不通过", value: 4});
    aEntitites.Rows.push({name: "退回整改", value: 5});
    aEntitites.Rows.push({name: "其他", value: 6});
  }


  return aEntitites;
}

export function getRyEducationalEntities() {
  let aEntities = mackEntitites();
  aEntities.Rows.push({name: "小学", value: 1});
  aEntities.Rows.push({name: "初中", value: 2});
  aEntities.Rows.push({name: "高中", value: 3});
  aEntities.Rows.push({name: "大专", value: 4});
  aEntities.Rows.push({name: "本科", value: 5});
  aEntities.Rows.push({name: "研究生", value: 6})
  aEntities.Rows.push({name: "博士", value: 7});
  return aEntities;
}
// 住宅人员登记人员类型

export function getZzRylxEntities(){
  let aEntities = mackEntitites();
  aEntities.Rows.push({name: "评估员", value: 1});
  aEntities.Rows.push({name: "评估项目负责人", value: 2});
  return aEntities;
}

// 专业工作业绩备注

export function getZygzyjbzEntities(){
  let aEntities = mackEntitites();
  aEntities.Rows.push({name: "近3年内完成的既有房屋检测鉴定、房屋主体结构检测、既有房屋改造加固设计施工、房屋外墙检测修缮设计施工相关代表项目，项目不少于10项，每个项目面积不少于1000m²", value: 1});
  aEntities.Rows.push({name: "作为技术骨干，近3年内完成的既有房屋检测鉴定、房屋主体结构检测、既有房屋改造加固设计施工、房屋外墙检测修缮设计施工相关代表项目，项目不少于20项，每个项目面积不少于1000m²", value: 2});
  return aEntities;
}

// 红花杯工程状态
export function getGcztEntities(){
  let aEntities = mackEntitites();
  aEntities.Rows.push({name:"在建",value:1})
  aEntities.Rows.push({name:"竣工",value:2})
  return aEntities
}
// 单位证书业务范围
export function getDwzsYwfwEntities(){
  let aEntities = mackEntitites();
  aEntities.Rows.push({name:"一级",value:"一级"})
  aEntities.Rows.push({name:"二级",value:"二级"})
  return aEntities
}
export function getRyzsXbEntities(){
  let aEntities = mackEntitites();
  aEntities.Rows.push({name:"全部",value:""})
  aEntities.Rows.push({name:"男",value:"男"})
  aEntities.Rows.push({name:"女",value:"女"})
  return aEntities
}
export function getRyzsKhxmEntities(){
  let aEntities = mackEntitites();
  aEntities.Rows.push({name:"城镇住宅专业评估综合知识",value:"城镇住宅专业评估综合知识"})
  aEntities.Rows.push({name:"结构损失调查",value:"结构损失调查"})
  return aEntities
}



// WEBPACK FOOTER //
// ./src/utils/entities.js